import { h } from "preact";

import i18n from "../i18n";

export default function TaskListHedaer() {
  return (
    <div class="task-list__header row">
      <div class="col s1">{i18n.t(`component.task_list_header.state`)}</div>
      <div class="col s5">{i18n.t(`component.task_list_header.title`)}</div>
      <div class="col s4">{i18n.t(`component.task_list_header.category`)}</div>
      <div class="col s2">{i18n.t(`component.task_list_header.duration`)}</div>
    </div>
  );
}
